import { performGetRequest } from '@atlassian/jira-fetch';
import type { ProjectId } from '@atlassian/jira-shared-types';

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (projectId: ProjectId) =>
	performGetRequest(`/rest/internal/2/project/${projectId}/hasValidatorsByIssueType`);
